import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(({v2}) => ({
    root: {
        width: v2 ? undefined : '100%',
    },
}));
